import React from 'react';
import MyDay from './Staff/MyDay/MyDay';

/** S2 (AB#2205, SG-06) — a staff member's home is My Day (was an English placeholder). */
const DashboardStaff: React.FC = () => <MyDay />;

export default DashboardStaff;
